import React from "react";
import PropTypes from "prop-types";

import { Tabs, Tab, Box, Typography, Grid } from "@material-ui/core";

import useStyles from "./styles";

const a11yProps = index => ({
  id: `scrollable-force-tab-${index}`,
  "aria-controls": `scrollable-force-tabpanel-${index}`
});

const TabPanel = props => {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      <Box p={2}>{children}</Box>
    </Typography>
  );
};

const TabsComponent = ({ tabs, iconSize = 20 }) => {
  const classes = useStyles({ iconSize });
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const filteredTabs = tabs.filter(({ renders }) => renders);

  return (
    <>
      <Grid container>
        <Tabs
          classes={{ root: classes.tabWrapper }}
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="on"
          aria-label="scrollable table"
        >
          {filteredTabs.map(({ title, icon }, i) => (
            <Tab
              key={i}
              icon={icon}
              {...a11yProps(i)}
              classes={{ root: classes.tab }}
              className={
                value === i ? classes.selectedTab : classes.unselectedTab
              }
            />
          ))}
        </Tabs>
      </Grid>
      {filteredTabs.map(({ component }, i) => (
        <TabPanel key={i} value={value} index={i} className={classes.tabPanel}>
          {component}
        </TabPanel>
      ))}
    </>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

TabsComponent.propTypes = {
  tabs: PropTypes.any.isRequired
};

export default TabsComponent;
